import * as apis from "./POR.api";
import * as queries from "./POR.queries";
import * as mutations from "./POR.mutations";

export default { ...apis, ...queries, ...mutations };
